// extracted by mini-css-extract-plugin
var _1 = "SocialShare__SocialShare___WJ2FC";
var _2 = "SocialShare__caption___uGyQT";
var _3 = "SocialShare__medium___eyIQr";
var _4 = "SocialShare__twitter____lttP";
var _5 = "SocialShare__wiggle___Tl6XB";
export { _1 as "SocialShare", _2 as "caption", _3 as "medium", _4 as "twitter", _5 as "wiggle" }
